//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalLogoVertical from '~/assets/images/logos/tidal-vertical.svg?inline';

export default {
    components: {
        tidalLogoVertical,
    },
    layout: 'dark-no-header',
    computed: {
        /** @return {string} */
        loginOrigin() {
            return process.env.LOGIN_ORIGIN;
        },
        /** @return {string} */
        offerOrigin() {
            return process.env.OFFER_ORIGIN;
        },
    },
};
